import {
  ScreenshotOutlined,
  InsertDriveFileOutlined,
  FolderOutlined,
  ChatBubbleOutlineOutlined,
  AddLinkOutlined,
  BarChartOutlined,
  PersonOutlineOutlined,
  CollectionsOutlined,
  GroupAddOutlined,
  AssignmentTurnedInOutlined,
  WorkspacePremiumOutlined,
  GroupsOutlined,
} from '@mui/icons-material';

export const ICONS = {
  ScreenshotOutlined,
  InsertDriveFileOutlined,
  FolderOutlined,
  ChatBubbleOutlineOutlined,
  AddLinkOutlined,
  BarChartOutlined,
  PersonOutlineOutlined,
  CollectionsOutlined,
  GroupAddOutlined,
  AssignmentTurnedInOutlined,
  WorkspacePremiumOutlined,
  GroupsOutlined,
};
